import { ModalFooter, ModalMain } from "@/components/ui/Drawer";
import { Link } from "@/i18n/Link";
import { sbLink } from "@/lib/storyblok/link";
import { clsx } from "@frend-digital/ui";
import { Newsletter } from "../Footer/components/Newsletter";
import { GeoSelectorTrigger } from "../GeoSelector";
import { GeoStatus } from "../GeoSelector/GeoStatus";
import styles from "./Header.module.css";
import { MobileAccountPoints } from "./MobileAccountPoints";
import { MobileSection } from "./MobileSection";

import { SegmentControl } from "@/components/SegmentControl";
import type { RPC } from "@/data/routes/router";
import type { BlokNavigation } from "@/storyblok";
import type { StoryblokRichtext } from "@/storyblok-base";
import type { StoryblokMultilink } from "storyblok";

// "My Account" is a plain CMS link (content.mobileLinks) rather than a dedicated
// field, so it's identified by URL — mirroring the existing isOutletSection URL
// check in MobileSection.tsx, since the nav schema has no field to drive this from
// the CMS instead. The Outlet "Member exclusive" tag only shows on the main-sections
// entry (MobileSection.tsx), not here, so it appears exactly once in the menu.
const isAccountLink = (href: string) => href.includes("/account");

export const MobileMenuContent = ({
	preview,
	content,
	signupTerms,
}: {
	preview: boolean;
	content: BlokNavigation;
	signupTerms?: StoryblokRichtext;
}) => {
	const hrefsToRemove = content.mobileLinks
		?.map((link) => sbLink(link.link as StoryblokMultilink)?.href)
		.filter(Boolean);

	return (
		<>
			<div className={styles.mobileMenuContent}>
				<ModalMain className={clsx(styles.menuSections)}>
					{content.sections?.map((section) => {
						return (
							<MobileSection
								preview={preview}
								key={section._uid}
								section={section}
								removeHrefs={hrefsToRemove}
							/>
						);
					})}

					<nav data-slide-left className={styles.bottomNav}>
						<menu>
							{content.mobileLinks?.map((item) => {
								const link = sbLink(item.link as StoryblokMultilink);
								if (!link) return null;
								return (
									<SegmentControl segments={item} key={item._uid}>
										<li className={styles.link}>
											<span className={styles.linkRow}>
												<Link href={link.href}>{item.text}</Link>
												{isAccountLink(link.href) && <MobileAccountPoints />}
											</span>
										</li>
									</SegmentControl>
								);
							})}
						</menu>
					</nav>

					<div data-slide-left>
						<Newsletter
							text={content.text}
							placeholder={content.placeholder}
							id="newsletter-mobile"
							signupTerms={signupTerms}
						/>
					</div>
				</ModalMain>
			</div>
			<ModalFooter className={styles.mobileMenuFooter}>
				<GeoSelectorTrigger>
					<GeoStatus />
				</GeoSelectorTrigger>
			</ModalFooter>
		</>
	);
};
